export function selectRows(selected: Array<unknown>, row: unknown, comparefn: unknown): Array<unknown> {
  const selectedIndex = (comparefn as (r: unknown, s: Array<unknown>) => number)(row, selected);

  if (selectedIndex > -1) {
    selected.splice(selectedIndex, 1);
  } else {
    selected.push(row);
  }

  return selected;
}

export function selectRowsBetween(
  selected: Array<unknown>,
  rows: Array<unknown>,
  index: number,
  prevIndex: number,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _comparefn: unknown
): Array<unknown> {
  const reverse = index < prevIndex;

  for (let i = 0; i < rows.length; i++) {
    const row = rows[i];
    const greater = i >= prevIndex && i <= index;
    const lesser = i <= prevIndex && i >= index;

    let range: { start: number; end: number };
    if (reverse) {
      range = {
        start: index,
        end: prevIndex
      };
    } else {
      range = {
        start: prevIndex,
        end: index + 1
      };
    }

    if ((reverse && lesser) || (!reverse && greater)) {
      // if in the positive range to be added to `selected`, and
      // not already in the selected array, add it
      if (i >= range.start && i <= range.end) {
        selected.push(row);
      }
    }
  }

  return selected;
}
